import { types } from 'mobx-state-tree';
import { FieldState, FormState, Validator } from 'formstate';
import { matchesRegExp } from '../../../shared/validators/RegularExpressionValidator';
import { required } from '../../../shared/validators/RequiredValidator';

export const MexicoCurpTaxEntry = types
  .model({
    curpId: types.maybe(types.string),
    curpIdRegExp: types.string,
    isRequired: types.boolean
  })
  .volatile(() => ({
    _reactForm: null as FormState<{ curpId: FieldState<string> }> | null
  }))
  .views(self => ({
    get validators() {
      const validators: Validator<string>[] = [];
      if (self.isRequired) {
        validators.push(required());
      }

      validators.push(matchesRegExp(self.curpIdRegExp));
      return validators;
    },
    get reactForm(): FormState<{ curpId: FieldState<string> }> {
      return self._reactForm!;
    }
  }))
  .actions(self => ({
    afterCreate() {
      self._reactForm = new FormState({
        curpId: new FieldState(self.curpId || '').validators(...self.validators)
      });
    }
  }))
  .named('MexicoCurpTaxEntry');
